module.exports = __webpack_public_path__ + "static/media/user-image-with-black-background (1).66c5eb79.png";